'use strict';
var requireObjectCoercible = require('../internals/require-object-coercible');

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/to-object.js
// module id = 1003
// module chunks = 0